import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subscription, Observable, interval } from 'rxjs';
import { Router } from '@angular/router';
import { SchedulerService } from '../scheduler.service';
import { HttpResponseBase } from '@angular/common/http';
import { ServerResponseCode } from './response.code.constants';
import { ScheduleRequest, SchedulerResultData } from '../scheduler.model';
import { DatePipe } from '@angular/common';
import { MatTableDataSource, MatSort, MatSortable, Sort, MatIconRegistry, SortDirection, MatSortHeader } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'oap-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit, OnDestroy {
  schedulerForm: FormGroup;
  jobNameStatus: String;
  jobRecords = [];
  //jobRefreshTimerSubscription: Subscription;

  displayedColumns: string[] = ['rowId', 'jobName', 'cronExpression', 'scheduleTime', 'lastFiredTime', 'nextFireTime', 'jobStatus', 'actions'];
  dataSource: MatTableDataSource<SchedulerResultData>;
  @ViewChild(MatSort) sort: MatSort;

  mapSchedulerResultData: Map<number, SchedulerResultData>;
  currentSchedulerResult: SchedulerResultData;

  selectedRowIndex: number = -1;

  isEditMode: boolean = false;

  tooltip_start_now = "Exécuter le job immédiatement";
  tooltip_pause_job = "Mettre le job en pause";
  tooltip_resume_job = "Reprendre le job";
  tooltip_delete_job = "Supprimer le job";
  tooltip_stop_job = "Stopper l'exécution du job";
  tooltip_edit_job = "Editer le job";

  informations: string;

  jobNameRequested: string;

  constructor(private _router: Router,
    private _fb: FormBuilder,
    private _schedulerService: SchedulerService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer) {

    iconRegistry.addSvgIcon('startNow', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-play_circle_filled_white-24px.svg'));
    iconRegistry.addSvgIcon('pauseJob', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-pause_presentation-24px.svg'));
    iconRegistry.addSvgIcon('resumeJob', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-restore-24px.svg'));
    iconRegistry.addSvgIcon('deleteJob', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-delete-24px.svg'));
    iconRegistry.addSvgIcon('stopJob', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-cancel_presentation-24px.svg'));
    iconRegistry.addSvgIcon('editJob', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/outline-edit-24px.svg'));

  }

  ngOnInit() {
    this.jobNameStatus = "";
    this.jobNameRequested = "";

    this.schedulerForm = this._fb.group({
      jobName: [''],
      year: [''],
      month: [''],
      day: [''],
      hour: [''],
      minute: [''],
      cronExpression: ['0 0/1 * 1/1 * ? *']
    });
    this.setDate();
    this.getJobs();

    this.sort.sort({
      id: "nextFireTime",
      start: "asc",
      disableClear: true
    });

  }

  ngOnDestroy() {
    //this.jobRefreshTimerSubscription.unsubscribe();
  }

  onRowClick(row) {
    //console.log('**** row click');
    //console.log(row);
    //console.log('****************');
    this.selectedRowIndex = row.rowId;
    this.currentSchedulerResult = this.mapSchedulerResultData.get(row.rowId);
    //this.setForm(this.currentAdmin);
  }

  onSortData(sort: Sort) {
    this.sortData();
  }

  private sortData() {
    console.log("sorData")
    if (!this.dataSource) {
      return;
    }

    const data = this.dataSource.data;

    let sort: Sort = {
      active: this.sort.active,
      direction: this.sort.direction
    };

    if (!sort.active || sort.direction === '') {
      // tri par défaut
      sort = {
        active: "",
        direction: ""
      };
    }

    this.dataSource = new MatTableDataSource(data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'jobName': return compare(a.jobName, b.jobName, isAsc);
        case 'nextFireTime': return compare(a.nextFireTime, b.nextFireTime, isAsc);
        case 'lastFiredTime': return compare(a.lastFiredTime, b.lastFiredTime, isAsc);
        default: return compare(a.rowId, b.rowId, true);
      }
    }));
  }

  setDate(): void {
    let date = new Date();
    this.schedulerForm.patchValue({
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hour: date.getHours(),
      minute: date.getMinutes()
    });
  }

  resetForm() {
    var dateNow = new Date();
    this.schedulerForm.patchValue({
      jobName: "",
      year: dateNow.getFullYear(),
      month: dateNow.getMonth() + 1,
      day: dateNow.getDate(),
      hour: dateNow.getHours(),
      minute: dateNow.getMinutes()
    });
    this.jobNameStatus = "";
  }

  getJobs() {
    this._schedulerService.getJobs()
      .subscribe(
        response => {
          console.log('http response status : ' + response.status);
          let data = response.body.data;

          const results: SchedulerResultData[] = [];
          this.mapSchedulerResultData = new Map<number, SchedulerResultData>();
          let i: number = 1;
          let current: SchedulerResultData;
          data.forEach(element => {
            let entity: SchedulerResultData = createSchedulerResultData(i, element);
            results.push(entity);
            this.mapSchedulerResultData.set(entity.rowId, entity);
            if (i == this.selectedRowIndex) {
              current = entity;
            }
            i++;
          });
          this.dataSource = new MatTableDataSource(results);

          this.sortData();

          if (this.selectedRowIndex > 0) {
            this.onRowClick(current);
          }

        },
        error => {
          console.error(error)
        });
  }

  getFormattedDate(year, month, day, hour, minute) {
    return year + "/" + month + "/" + day + " " + hour + ":" + minute;
  }


  scheduleJob() {
    var jobName = this.schedulerForm.value.jobName;
    var year = this.schedulerForm.value.year;
    var month = this.schedulerForm.value.month;
    var day = this.schedulerForm.value.day;
    var hour = this.schedulerForm.value.hour;
    var minute = this.schedulerForm.value.minute;

    var scheduleRequest: ScheduleRequest = {
      "jobClass": "aaa",
      "jobName": this.schedulerForm.value.jobName,
      "cronExpression": this.schedulerForm.value.cronExpression,
      "jobScheduleTime": this.getFormattedDate(year, month, day, hour, minute)
    };

    this._schedulerService.scheduleJob(scheduleRequest).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;

        if (serverResponse.statusCode == ServerResponseCode.SUCCESS) {
          alert("Job scheduled successfully.");
          this.resetForm();
        } else if (serverResponse.statusCode == ServerResponseCode.JOB_WITH_SAME_NAME_EXIST) {
          alert("Job with same name exists, Please choose different name.");

        } else if (serverResponse.statusCode == ServerResponseCode.JOB_NAME_NOT_PRESENT) {
          alert("Job name is mandatory.");
        }
        this.jobRecords = serverResponse.data;
      },
      err => {
        alert("Error while getting all jobs");
      });
  }

  updateJob() {
    var jobName = this.schedulerForm.value.jobName;
    var year = this.schedulerForm.value.year;
    var month = this.schedulerForm.value.month;
    var day = this.schedulerForm.value.day;
    var hour = this.schedulerForm.value.hour;
    var minute = this.schedulerForm.value.minute;

    let ScheduleUpdateRequest = {
      "jobName": this.schedulerForm.value.jobName,
      "cronExpression": this.schedulerForm.value.cronExpression,
      "jobScheduleTime": this.getFormattedDate(year, month, day, hour, minute)
    }

    this._schedulerService.updateJob(ScheduleUpdateRequest).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;

        if (serverResponse.statusCode == ServerResponseCode.SUCCESS) {
          alert("Job updated successfully.");
          this.resetForm();

        } else if (serverResponse.statusCode == ServerResponseCode.JOB_DOESNT_EXIST) {
          alert("Job no longer exist.");

        } else if (serverResponse.statusCode == ServerResponseCode.JOB_NAME_NOT_PRESENT) {
          alert("Please provide job name.");
        }
        this.jobRecords = serverResponse.data;
      },
      err => {
        alert("Error while updating job");
      });
  }

  pauseJob(jobName: string) {
    this._schedulerService.pauseJob(jobName).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;
        if (serverResponse.statusCode == ServerResponseCode.SUCCESS && serverResponse.data == true) {
          this.displayTextFor("La tâche est en pause.", 3000);
        } else if (serverResponse.data == false) {
          if (serverResponse.statusCode == ServerResponseCode.JOB_ALREADY_IN_RUNNING_STATE) {
            this.displayTextFor("La tâche est encours, elle ne peut pas être mise en pause.", 3000);
          }
        }
        this.getJobs();
      },
      err => {
        console.log(err);
        this.displayTextFor("Erreur lors de la mise en pause.", 3000);
      });
  }

  resumeJob(jobName: string) {
    this._schedulerService.resumeJob(jobName).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;
        if (serverResponse.statusCode == ServerResponseCode.SUCCESS && serverResponse.data == true) {
          this.displayTextFor("La tâche a été remise en fonction avec succès.", 3000);
        } else if (serverResponse.data == false) {
          if (serverResponse.statusCode == ServerResponseCode.JOB_NOT_IN_PAUSED_STATE) {
            this.displayTextFor("La tâche n'est pas en pause, elle ne peut pas être remise en fonction.", 3000);
          }
        }

        //For updating fresh status of all jobs 
        this.getJobs();
      },
      err => {
        console.log(err);
        this.displayTextFor("Erreur lors de la remise en fonction.", 3000);
      });

  }

  stopJob(jobName: string) {
    this._schedulerService.stopJob(jobName).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;
        if (serverResponse.statusCode == ServerResponseCode.SUCCESS && serverResponse.data == true) {
          this.displayTextFor("La tâche arrêté avec succès.", 3000);
        } else if (serverResponse.data == false) {
          if (serverResponse.statusCode == ServerResponseCode.JOB_NOT_IN_RUNNING_STATE) {
            this.displayTextFor("La tâche n'a pas commencé, elle ne peut pas être arrêté.", 3000);
          } else if (serverResponse.statusCode == ServerResponseCode.JOB_ALREADY_IN_RUNNING_STATE) {
            this.displayTextFor("La tâche est déjà commencé.", 3000);
          } else if (serverResponse.statusCode == ServerResponseCode.JOB_DOESNT_EXIST) {
            this.displayTextFor("La tâche n'existe plus..", 3000);
          }
        }

        this.getJobs();
      },
      err => {
        console.log(err);
        this.displayTextFor("Erreur lors de l'arrêt.", 3000);
      });
  }

  startJobNow(jobName: string) {
    this._schedulerService.startJobNow(jobName).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;
        if (serverResponse.statusCode == ServerResponseCode.SUCCESS && serverResponse.data == true) {
          this.displayTextFor("La tâche a été exécuté avec succès.", 3000);
        } else if (serverResponse.data == false) {
          if (serverResponse.statusCode == ServerResponseCode.ERROR) {
            this.displayTextFor("Erreur lors du lancement de la tâche.", 3000);
          } else if (serverResponse.statusCode == ServerResponseCode.JOB_ALREADY_IN_RUNNING_STATE) {
            this.displayTextFor("La tâche est déjà commencé.", 3000);
          } else if (serverResponse.statusCode == ServerResponseCode.JOB_DOESNT_EXIST) {
            this.displayTextFor("La tâche n'existe plus.", 3000);
          }
        }

        this.getJobs();
      },
      err => {
        console.log(err);
        this.displayTextFor("Erreur lors du lancement de la tâche.", 3000);
      });
  }

  private displayTextFor(text: string, displayTime: number) {
    this.informations = text;
    setTimeout(() => { this.informations = "" }, displayTime);
  }

  deleteJob(jobName: string) {
    this._schedulerService.deleteJob(jobName).subscribe(
      response => {
        console.log('http response status : ' + response.status);
        let serverResponse = response.body;
        if (serverResponse.statusCode == ServerResponseCode.SUCCESS && serverResponse.data == true) {
          this.displayTextFor("La tâche a été supprimé avec succès.", 3000);
        } else if (serverResponse.data == false) {
          if (serverResponse.statusCode == ServerResponseCode.JOB_ALREADY_IN_RUNNING_STATE) {
            this.displayTextFor("La tâche est encours, elle ne peut pas être supprimé.", 3000);
          } else if (serverResponse.statusCode == ServerResponseCode.JOB_DOESNT_EXIST) {
            alert("Job no longer exist.");
            this.displayTextFor("La tâche n'existe plus.", 3000);
          }
        }

        //For updating fresh status of all jobs
        this.getJobs();
      },
      err => {
        console.log(err);
        this.displayTextFor("Erreur lors de la suppression de la tâche.", 3000);
      });
  }

  refreshJob() {
    //For updating fresh status of all jobs 
    this.getJobs();
  }

  cronChange(cronExp) {
    this.schedulerForm.patchValue({
      cronExpression: cronExp
    });
  }
}

function compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

/** Builds and returns a new SearchResultData. */
function createSchedulerResultData(rowId: number, data: any): SchedulerResultData {
  return {
    rowId: rowId,
    jobName: data.jobName,
    groupName: data.groupName,
    jobType: data.jobType,
    scheduleTime: data.scheduleTime,
    lastFiredTime: data.lastFiredTime,
    nextFireTime: data.nextFireTime,
    jobStatus: data.jobStatus,
    cronExpression: data.cronExpression
  }
}
